import { Project } from '../types/Project.type';
import { getApiPath } from './getApiPath';
import handleRequestError from './handleRequestError';
import { apiClient } from './utils';

export default async function patchUpdateCurrency(
  projectId: Project['_id'],
  currency: string,
): Promise<undefined | null> {
  try {
    await apiClient.patch(getApiPath('PROJECTS.PROJECT', { projectId }), {
      currency,
    });
  } catch (error) {
    handleRequestError(error);
    return null;
  }
}
